"use client"

import { useState, useEffect } from "react"
import { PageLayout } from "@/components/page-layout"
import { SimpleCalculatorForm } from "@/components/calculator-form-simple"
import { ResultsPanel } from "@/components/results-panel"
import { AuthGuard } from "@/components/auth-guard"
import type { ProcessedDLOMResults } from "@/lib/api-service"

export default function CalculatorPage() {
  const [calculationResults, setCalculationResults] = useState<ProcessedDLOMResults | undefined>(undefined)

  useEffect(() => {
    console.log("[v0] CalculatorPage component mounted")
  }, [])

  const handleResultsCalculated = (results: ProcessedDLOMResults) => {
    console.log("[v0] Results received in CalculatorPage:", results)
    setCalculationResults(results)
  }

  return (
    <AuthGuard>
      <PageLayout>
        <div className="min-h-screen bg-background">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="grid grid-cols-1 xl:grid-cols-4 gap-6">
              {/* Calculator Form - Left Side */}
              <div className="xl:col-span-1">
                <div className="sticky top-6">
                  <SimpleCalculatorForm onResultsCalculated={handleResultsCalculated} />
                </div>
              </div>
              
              {/* Results Panel - Right Side */}
              <div className="xl:col-span-3">
                <ResultsPanel results={calculationResults} />
              </div>
            </div>
          </div>
        </div>
      </PageLayout>
    </AuthGuard>
  )
}
